import React, { useEffect, useState } from 'react';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import Menu from './modules/components/menu';
import WelcomeHeader from './modules/components/welcome-header';
import ServiceSection from './modules/components/service-section';
import SkiTransfersSection from './modules/components/ski-transfers-section';
import VehiculesSection from './modules/components/vehicules';
import ContactSection from './modules/components/contact';
import Footer from './modules/sections/footer';

import { ThemeProvider, createTheme } from '@mui/material';

import './App.css';


// import { APIProvider, Map, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';>

// const GOOGLE_MAP_API_KEY = 'AIzaSyA6HyP2mA-TXau94xMtljsP3HjUFDdc5CQ';

const theme = createTheme({
	components: {
		MuiStepLabel: {
			styleOverrides: {
				label: {
					fontSize: '0.9rem',
					fontWeight: 600,
					fontFamily: 'Montserrat',
					color: '#C1C1C1',
					textTransform: 'uppercase',
					padding: '0 65px'
				},
			},
		},
	},
});


const stripePromise = loadStripe("pk_test_51QmMdVFWDK1i39iejFE4Iu79VLxvQLkmDHfGmqIFxRoVc0RyW2Ou5lvJxaI1s9Jz7BdPKMjgIrMUATczy5mx3Lv1006Q7Ii0HL");


function App() {

	const [clientSecret, setClientSecret] = useState("");

	useEffect(() => {
		// Create PaymentIntent as soon as the page loads
		// fetch("http://localhost:4000/create-payment-intent", {
		// 	method: "POST",
		// 	headers: { "Content-Type": "application/json" },
		// 	body: JSON.stringify({ items: [{ id: "xl-tshirt", amount: 1000 }] }),
		// })
		// .then((res) => res.json())
		// .then((data) => {
		// 	console.log('--> REceive data', data);
		// 	setClientSecret(data.clientSecret);
		// });
	}, []);

	const appearance = {
		theme: 'flat',
	};
	// Enable the skeleton loader UI for optimal loading.
	const loader = 'auto';

	// if( !clientSecret ) {
	// 	return null;
	// }

	return (
		<div className="App">
			<ThemeProvider theme={theme}>
				{/* <Elements options={{clientSecret, appearance, loader}} stripe={stripePromise}> */}
				{/* <APIProvider apiKey={GOOGLE_MAP_API_KEY}> */}
					<Menu />
					<WelcomeHeader />
					<ServiceSection />
					<SkiTransfersSection />
					<VehiculesSection />
					<ContactSection />
					<Footer />
				{/* </APIProvider> */}
				{/* </Elements> */}
			</ThemeProvider>
		</div>
	);
}

export default App;
